/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 8/4/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */

function add0(n) {
  return n < 10 ? "0" + n : n.toString();
}

export default function(value) {
  if (0 < value && value <= 31536e6) {
    value /= 1e3;
  } else {
    value = 0;
  }
  var h = Math.floor(value / 3600);
  var m = Math.floor(value / 60 - h * 60);
  var s = Math.floor(value - h * 60 * 60 - m * 60);
  return (h ? add0(Math.min(h, 99)) + ":" : "") + add0(m) + ":" + add0(s);
}
